var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 68.5H68",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 32.5V68.5H52.5V32.5C52.5 30.3 51.6 28.5 48.9 28.5H47.1C44.4 28.5 43.5 30.3 43.5 32.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44.5V68.5H38V44.5C38 42.3 37.2 40.5 34.8 40.5H33.2C30.8 40.5 30 42.3 30 44.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54.5V68.5H66V54.5C66 52.3 65.2 50.5 62.8 50.5H61.2C58.8 50.5 58 52.3 58 54.5Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.f9ec1fdac030b932b3c9ba8e89dc22a7.svg";
export { ForwardRef as ReactComponent };